// page-default.jsx — デフォルトの固定ページ（page.php）

(function(){
  const { HBLayout, HBSubHero, hbcp, fontEN, fontENSans, fontJP, fontMono } = window;

  function DefaultPage() {
    const d = window.HB_PAGE || { title:'', content_html:'' };
    return (
      <HBLayout>
        <HBSubHero crumb="Page" en="Page" jp={d.title} tag={null} lead={null} />
        <section style={{padding:'56px 32px 96px', background:hbcp.white}}>
          <div className="hb-article" style={{maxWidth:760, margin:'0 auto', fontSize:16, lineHeight:1.95, color:hbcp.ink}}
               dangerouslySetInnerHTML={{ __html: d.content_html }} />
          <style>{`
            .hb-article p { margin: 0 0 1.4em; }
            .hb-article h2 { font-family: ${fontJP}; font-weight:800; font-size:24px; line-height:1.45; margin:48px 0 16px; padding-top:24px; border-top:1px solid ${hbcp.line}; letter-spacing:.04em; }
            .hb-article h3 { font-family: ${fontJP}; font-weight:700; font-size:19px; line-height:1.5; margin:32px 0 12px; }
            .hb-article a { color:${hbcp.blue}; text-decoration: underline; text-underline-offset: .2em; }
            .hb-article ul, .hb-article ol { padding-left: 1.4em; margin: 0 0 1.4em; }
            .hb-article li { margin: .4em 0; }
            .hb-article blockquote { margin: 24px 0; padding: 18px 24px; border-left: 3px solid ${hbcp.blue}; background: ${hbcp.paper}; color: ${hbcp.inkSoft}; font-size: 15px; }
            .hb-article img { max-width: 100%; height: auto; margin: 24px 0; }
            .hb-article table { border-collapse: collapse; width: 100%; margin: 24px 0; font-size: 14px; }
            .hb-article th, .hb-article td { border: 1px solid ${hbcp.line}; padding: 10px 14px; text-align: left; }
            .hb-article th { background: ${hbcp.paper}; font-weight: 700; }
          `}</style>
        </section>
      </HBLayout>
    );
  }

  Object.assign(window, { DefaultPage });
})();
